import { CompassIcon, HomeIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { EmptyState } from '@/shared/components/empty-state';
import { useDocumentTitle } from '@/shared/components/page-header';
import { Button } from '@/shared/ui/button';

export function NotFoundPage() {
  const { t } = useTranslation('app');
  useDocumentTitle(t('errors.notFoundTitle'));
  return (
    <div className="flex flex-1 items-center justify-center" data-testid="not-found">
      <EmptyState
        size="lg"
        icon={CompassIcon}
        title={
          <span className="flex flex-col items-center gap-2">
            <span className="text-5xl font-semibold tracking-[-0.04em] text-subtle-foreground tabular-nums">
              404
            </span>
            {t('errors.notFoundTitle')}
          </span>
        }
        description={t('errors.notFoundDescription')}
        action={
          <Button asChild>
            <Link to="/">
              <HomeIcon />
              {t('errors.goHome')}
            </Link>
          </Button>
        }
      />
    </div>
  );
}
